import { configServices, helpers } from 'src/services';
import { Container, FloatingLabel, Form } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    setShowInvitationForNewCongregation: Dispatch<SetStateAction<boolean>>;
};

export const ConfigSendInvitationNewCongregation: FC<propsType> = ({ setShowInvitationForNewCongregation }) => {
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const sendInvitationForNewCongregationHandler = async () => {
        if (!generalHelpers.IsValidEmail(email)) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se le va a enviar una invitación a ${email} para que cree y sea administrador de una nueva Congregación`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await configServices.SendInvitationForNewUser(email, true);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: 'Logrado',
                    message: `Se envió una invitación para crear una Congregación a ${email}`,
                    animation: 1,
                    execution: () => setShowInvitationForNewCongregation(false)
                }));
            }
        }));
    }

    useEffect(() => {
        helpers.GoToTop();
    }, []);

    return (
        <Container className={'maxw-400 mt-4'}>

            <h3 className={`text-center mt-5 ${isDarkMode ? 'text-white' : ''}`}>
                Enviar por Email un acceso para ser administrador y primer usuario de una Congregación nueva
            </h3>

            <FloatingLabel
                className={'mt-5 mb-3 text-dark'}
                label={'Dirección de email'}
            >
                <Form.Control
                    type={'email'}
                    className={'form-control'}
                    placeholder={''}
                    value={email}
                    onChange={e => setEmail((e.target as HTMLInputElement).value)}
                    onKeyDown={e => e.key === 'Enter' ? sendInvitationForNewCongregationHandler() : null }
                    autoFocus
                />
            </FloatingLabel>

            <button
                className={`btn btn-general-blue d-block w-100 mt-3`}
                style={{ fontWeight: 'bolder', height: '50px' }}
                onClick={sendInvitationForNewCongregationHandler}
                disabled={!generalHelpers.IsValidEmail(email)}
            >
                Aceptar
            </button>

            <button
                className={`btn btn-general-red d-block w-100 mt-3`}
                style={{ fontWeight: 'bolder', height: '50px' }}
                onClick={() => setShowInvitationForNewCongregation(false)}
            >
                Cancelar
            </button>
        </Container>
    );
}
